export default __webpack_public_path__ + "static/media/Yes_Results_Icon.7ee3727e.svg";